var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6503 6.35C16.2003 4.9 14.2103 4 12.0003 4C7.58025 4 4.01025 7.58 4.01025 12C4.01025 16.42 7.58025 20 12.0003 20C15.7303 20 18.8403 17.45 19.7303 14H17.6503C16.8303 16.33 14.6103 18 12.0003 18C8.69025 18 6.00025 15.31 6.00025 12C6.00025 8.69 8.69025 6 12.0003 6C13.6603 6 15.1403 6.69 16.2203 7.78L13.0003 11H20.0003V4L17.6503 6.35Z",
    fill: "#00CBAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshGreen);
export default __webpack_public_path__ + "static/media/refresh-green.4a59e41d217a00a03a2a5687dcf9b962.svg";
export { ForwardRef as ReactComponent };